<script lang="ts" setup>
import type { PreviewItemData } from '@autobid/strapi-integration/typescript/auction/carPreview'
import type { AuctionCar, BarometerCar, DetailsCarItemData } from '@autobid/ui/types/Car'
import { usePopupStore } from '@autobid/nuxt-pinia-store/store/usePopupStore'
import CommonLink from '@autobid/ui/components/common/Link.vue'
import { useTaxationPopup } from '@autobid/ui/composables/car/useTaxationPopup'

interface Props {
  car: AuctionCar | BarometerCar | DetailsCarItemData | PreviewItemData
  label?: string
  taxPopupSlug?: string
}

const props = defineProps<Props>()
const { handleClickLink } = usePopupStore()
const { setTaxPopupData } = useTaxationPopup()
const vatRate = props.car.additionalInformation?.itemLocationCountry?.vatRate

function preparePopupData() {
  if (!props.taxPopupSlug || !vatRate)
    return

  setTaxPopupData(props.taxPopupSlug, vatRate)
}

function handleClick(event: Event) {
  preparePopupData()
  handleClickLink(event)
}
</script>

<template>
  <CommonTooltip :tooltip="$t('cars-list.taxation-notes')">
    <component
      :is="taxPopupSlug ? CommonLink : 'span'"
      v-bind="{
        ...$attrs,
        ...(taxPopupSlug
          ? {
            href: `#popup-${taxPopupSlug}`,
          }
          : {}),
      }"
      @mouseenter="preparePopupData"
      @click.stop="handleClick"
    >
      {{ label ?? car.taxInformation }}
    </component>
  </CommonTooltip>
</template>
